module.exports = __webpack_public_path__ + "img/root.09a41ef6.png";